<!-- eslint-disable vue/singleline-html-element-content-newline -->
<template>
  <!-- wenn socket verbindung abbricht alles überdecken mit dieser div box um eingaben zu verhindern -->
  <div
    v-if="wsconnected === false"
    id="unconnected"
    class="modal"
  >
    <svg
      id="svgWsConnected"
      version="1.1"
      viewBox="0 0 12.708006 12.7"
    >
      <defs
        id="defs2"
      />
      <g
        id="layer1"
        transform="translate(-38.658384,-40.713808)"
      >
        <g
          id="g826"
          transform="translate(-4.8108519,-18.174328)"
        >
          <path
            id="path836"
            d="m 49.885911,58.888497 c -1.692733,-0.01755 -3.257538,0.605947 -4.474408,1.785891 -0.559684,0.542701 -0.941029,1.064008 -1.282258,1.752744 -1.008231,2.035002 -0.852767,4.452784 0.407636,6.33927 0.786717,1.177504 1.937452,2.059119 3.259453,2.497214 0.419283,0.138947 0.93212,0.257428 1.289842,0.298011 0.352729,0.04002 1.192675,0.03362 1.53853,-0.01172 0.899419,-0.117904 1.811128,-0.440049 2.556668,-0.90342 1.072111,-0.666343 1.985922,-1.723992 2.474781,-2.864279 0.27019,-0.630234 0.397265,-1.116575 0.504375,-1.930733 0.02823,-0.214596 0.01894,-1.067156 -0.01469,-1.347016 -0.272425,-2.267121 -1.755121,-4.244987 -3.835586,-5.116625 -0.753542,-0.315705 -1.444937,-0.467348 -2.260088,-0.495624 -0.05487,-0.0019 -0.10965,-0.0031 -0.164254,-0.0037 z m 1.367275,2.955395 c 0.294114,-0.0085 0.55127,0.283718 0.465447,0.602439 -0.0263,0.09766 -0.124983,0.20983 -0.652877,0.742084 -0.342035,0.344861 -0.621903,0.638602 -0.621903,0.652771 0,0.03447 0.848542,0.880508 0.883107,0.880508 0.01489,0 0.289689,-0.263596 0.61066,-0.585733 0.320973,-0.322136 0.628915,-0.609295 0.684328,-0.638132 0.275515,-0.143383 0.625497,0.02757 0.665393,0.325006 0.03396,0.253153 0.02642,0.263972 -0.659772,0.954123 l -0.635428,0.639141 0.175816,0.174277 c 0.0967,0.09584 0.194367,0.213352 0.217024,0.261098 0.05193,0.109433 0.05313,0.316709 0.0024,0.412569 -0.02135,0.04033 -0.167987,0.201392 -0.325856,0.357942 -0.157869,0.156551 -0.287032,0.297019 -0.287032,0.312119 0,0.0151 0.318591,0.346227 0.707982,0.735825 0.64816,0.648507 0.709202,0.717544 0.722567,0.817184 0.01819,0.135623 -0.04313,0.263831 -0.153435,0.320869 -0.124018,0.06413 -0.250098,0.05164 -0.370193,-0.0367 -0.05825,-0.04284 -0.367438,-0.345278 -0.687085,-0.672076 -0.319648,-0.326797 -1.715734,-1.730849 -3.102412,-3.120073 -2.453831,-2.458335 -2.521186,-2.528583 -2.521186,-2.628532 0,-0.208559 0.135413,-0.343968 0.344841,-0.344789 0.09903,-3.88e-4 0.131467,0.02809 0.806471,0.708301 l 0.703314,0.708723 0.301405,-0.298223 c 0.323528,-0.320127 0.420269,-0.385202 0.572527,-0.385202 0.150325,0 0.273525,0.06536 0.459188,0.243648 0.09373,0.09 0.181702,0.163671 0.195492,0.163671 0.01379,0 0.299939,-0.276189 0.635852,-0.613737 0.335913,-0.337547 0.650058,-0.630816 0.698117,-0.65171 0.05506,-0.02393 0.110796,-0.03582 0.165261,-0.03739 z m -3.696152,2.68772 c 0.02289,0 0.731199,0.680421 1.574064,1.512065 1.168682,1.153125 1.530592,1.525397 1.524475,1.568178 -0.0066,0.04627 -0.05083,0.06707 -0.252399,0.118642 -0.276438,0.07073 -0.748653,0.09861 -0.998939,0.05903 -1.070056,-0.169218 -1.893755,-1.02324 -2.029063,-2.103843 -0.03284,-0.262295 -0.01882,-0.518608 0.04386,-0.801061 0.05984,-0.269669 0.09246,-0.35301 0.138,-0.35301 z m -0.199417,2.66115 c 0.04173,0 0.615222,0.576906 0.615222,0.61888 0,0.05254 -0.5538,0.63263 -0.659985,0.691328 -0.08254,0.04563 -0.284425,0.06076 -0.37189,0.0279 -0.24253,-0.09113 -0.370365,-0.412816 -0.254415,-0.640254 0.04799,-0.09413 0.628544,-0.697852 0.671068,-0.697852 z"
            style="fill:#cd282e;stroke-width:0.02715459"
          />
        </g>
      </g>
    </svg>
  </div>

  <!-- Seiten Kopf -->
  <AppHeader />
  <!-- Navigationslinks -->
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <!-- Seiteninhalt -->
  <router-view />
  <!-- Fußzeile -->
  <!-- <AppFooter /> -->
</template>

<script>

// @ is an alias to /src
// import AppFooter from '@/components/AppFooter.vue';
import AppHeader from '@/components/AppHeader.vue';

export default {
  name: 'AppView',
  components: {
    AppHeader

    // AppFooter
  },
  data () {
    return {
      wsconnected: false
    };
  },
  sockets: {
    connect () {
      this.wsconnected = true;
    },
    disconnect () {
      this.wsconnected = false;
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%!important;
  background-color: rgba(33,37,41);
}

html, body {
  height: 100%!important;
}

nav {
  padding: 5px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #2f80af;
}

#unconnected {
  z-index: 1150;
  background-color: rgba(0,0,0,.7);
  display: flex;
  align-items: center;
}

#svgWsConnected {
  margin-left: auto;
  margin-right: auto;
  width: 72px;
}

</style>
